import { tableSchema } from '@nozbe/watermelondb'

export const pricesDataSchema = tableSchema({
  name: 'pricesData',
  columns: [
    { name: 'pricesDataId', type: 'string' },
    { name: 'dairyFarmId', type: 'string' },
    { name: 'price', type: 'string' },
    { name: 'manual', type: 'boolean' },
    { name: 'companyName', type: 'string' },
    { name: 'organizationId', type: 'string' },
    { name: 'priceDate', type: 'string' },
    { name: 'monthlyIncome', type: 'string' },
    { name: 'userId', type: 'string' },
    { name: 'userStateRegistrationId', type: 'string' },
    { name: 'costBulkId', type: 'string' },
    { name: 'deletedAt', type: 'string' },
    { name: 'createdAt', type: 'string' },
    { name: 'updatedAt', type: 'string' }
  ]
})